// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__qAjE6","headerSplit":"PageHeader_headerSplit__1qHpR"};